import { GDPRCookie, GDPR_PREFERENCES_COOKIE, getDomainNameFromHost, } from '@wkda/gdprlib';
import * as constants from './constants';
import { isEverythingSelected } from './helpers';
function getExpirationDate() {
    const expirateionDate = new Date();
    expirateionDate.setFullYear(expirateionDate.getFullYear() + 2);
    return expirateionDate;
}
export function createSubmitHandlers({ APIService, isProd, cookieService, onSubmit, }) {
    async function removeStorageKeys() {
        const gdprCookieService = await GDPRCookie.init(cookieService.getAll(), cookieService, isProd, APIService);
        try {
            Object.keys(localStorage).forEach((key) => {
                if (!gdprCookieService.isPermitted(key)) {
                    localStorage.removeItem(key);
                }
            });
        }
        catch (e) {
            console.error('LocalStorage unavailable');
        }
    }
    function getSelectedCategories(categories) {
        return Object.keys(categories).reduce((acc, key) => {
            return !categories[key] ? acc : [...acc, key];
        }, []);
    }
    async function submitAll(categoriesSelectionMap) {
        await APIService.post('/v1/gdpr-preferences/', {
            categories: getSelectedCategories(categoriesSelectionMap),
            currentUrl: window.location.href,
        });
    }
    function setCookies(categoriesSelectionMap) {
        const categories = getSelectedCategories(categoriesSelectionMap);
        const categoriesToSet = categories.length === 1 &&
            categories[0] === constants.categories.ESSENTIAL
            ? []
            : categories;
        cookieService.set(GDPR_PREFERENCES_COOKIE, {
            categories: categoriesToSet,
        }, {
            expires: getExpirationDate(),
            path: '/',
            sameSite: 'lax',
            domain: getDomainNameFromHost(window.location.host),
        });
    }
    return {
        async submit(categoriesSelectionMap) {
            setCookies(categoriesSelectionMap);
            if (isEverythingSelected(categoriesSelectionMap)) {
                await submitAll(categoriesSelectionMap);
            }
            try {
                await removeStorageKeys();
            }
            catch (error) {
                console.error('LocalStorage entries could not be cleared!');
            }
            if (typeof onSubmit === 'function') {
                onSubmit();
            }
        },
    };
}
